import React from 'react';
import { StoreSmallItemView } from './StoreSmallItemView';

const StoreSmallItemListContainer = ({ storeList, county, renderCounty = false }) => {
    let cities = [];
    let counties = [];

    if (storeList && storeList.length > 0 && county) {
        storeList = storeList.filter(e => e.storeRegion == county);
        cities = storeList.map(value => value.storeCity).filter((v, i, a) => a.indexOf(v) === i) || [];
        cities = cities.sort((a, b) => a.localeCompare(b)); // 'no' locale support
    }
    if (renderCounty) {
        counties = storeList.map(value => value.storeRegion).filter((v, i, a) => a.indexOf(v) === i) || [];
        counties = counties.sort((a, b) => a.localeCompare(b)); // 'no' locale support
    }
    return <>
        {cities && storeList && !renderCounty ? cities.map(city => {
            return <div key={city} className="countycategory_city_list">
                <div className="row">
                    <div className='columns small-2'>
                        <h5>{city}</h5>
                    </div>
                    {storeList.filter(store => store.storeCity === city).map(store => {
                        return <div className="columns small-11 medium-4 store-column countycategory_city_list" key={store.id}>
                            <StoreSmallItemView store={store} />
                        </div>
                    })}
                </div>
            </div>;
        }) : null}

        {cities && counties && storeList && renderCounty ? counties.map(county => {
            let countyCities = storeList.filter(s => s.storeRegion == county).map(val => val.storeCity).filter((v, i, a) => a.indexOf(v) === i); 
            countyCities = countyCities.sort((a, b) => a.localeCompare(b));

            return <div key={county} className="countycategory_city_list">
                <div className="row">
                    <div className='columns small-12'>
                        <h4>{county}</h4>
                    </div>
                    {countyCities.map(city => {
                        let cityStoreSorted = storeList.filter(s => s.storeCity == city).map(val => val.storeName).filter((v, i, a) => a.indexOf(v) === i);
                        cityStoreSorted = cityStoreSorted.sort((a, b) => a.localeCompare(b));

                        return <div key={city} className="columns small-12">
                            <div className="row countycategory_city_list">
                                <h5 className="columns small-2">{city}</h5>
                            </div>
                            <div className="columns small-10">
                                {cityStoreSorted.map(name => {
                                    return storeList.filter(store => store.storeName === name).map(store => {
                                        return <div className="columns small-12 medium-5 store-column countycategory_city_list" key={store.id}>
                                            <StoreSmallItemView store={store} />
                                        </div>
                                    })
                                })}
                            </div>
                        </div>;
                    })}
                </div>
            </div>;
        }) : null}

    </>;
}

export default StoreSmallItemListContainer;